export { default as FileEditLight } from './FileEditLight';
export { default as FileExcelLight } from './FileExcelLight';
export { default as FilePdfLight } from './FilePdfLight';
export { default as FilePowerpointLight } from './FilePowerpointLight';
export { default as FileWordLight } from './FileWordLight';
export { default as FolderLight } from './FolderLight';
export { default as Reader } from './Reader';
export { default as EditorIc } from './EditorIc';
